import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const postRegularClassSchedules = ({ data }) => {
  return api.post(`/admin/regular-class-schedules`, data);
};

export const usePostRegularClassSchedules = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: postRegularClassSchedules,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries({
        queryKey: [
          "regular-class-schedules",
          { id: args[0]?.data?.regular_class_id },
        ],
      });
    },
    ...restConfig,
  });
};
